class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.hideProductsIfSaleFilter();
    this.applyInitialSaleFilter();
    this.hideSingleOptionFilters();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initSearchFilter();
  }

  hideSingleOptionFilters() {
    const filterDropdowns = document.querySelectorAll('#FacetFiltersForm .accordion__section.facets__accordion-section');
    
    filterDropdowns.forEach((dropdown) => {
      const availableOptions = dropdown.querySelectorAll('.facets__item input[type="checkbox"]:not([disabled])');
      
      if (availableOptions.length === 1) {
        dropdown.style.display = 'none';
      } else {
        dropdown.style.display = 'block';
      }
    });
  }

  hideProductsIfSaleFilter() {
    if (this.dataset.saleFilter !== 'true') return;

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('filter.p.m.filter.is_on_sale')) {
      return;
    }

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      productGrid.style.opacity = '0';
      productGrid.style.transition = 'opacity 0.3s ease-in-out';
    }

    const productCount = document.getElementById('ProductCount');
    const productCountDesktop = document.getElementById('ProductCountDesktop');
    if (productCount) {
      productCount.style.opacity = '0';
      productCount.style.transition = 'opacity 0.3s ease-in-out';
    }
    if (productCountDesktop) {
      productCountDesktop.style.opacity = '0';
      productCountDesktop.style.transition = 'opacity 0.3s ease-in-out';
    }

    this.showLoadingState();
  }

  showLoadingState() {
    const productGrid = document.getElementById('ProductGridContainer');
    if (!productGrid) return;

    const loader = document.createElement('div');
    loader.className = 'facets-loading-placeholder';
    loader.innerHTML = `
      <style>
        .facets-loading-placeholder {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          padding: 2rem;
          opacity: 0;
          animation: fadeIn 0.3s ease-in-out 0.2s forwards;
        }
        @keyframes fadeIn {
          to { opacity: 1; }
        }
        .facets-loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: var(--color-foreground, #333);
          animation: spin 1s ease-in-out infinite;
          margin: 0 auto 1rem;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
      <div class="facets-loading-spinner"></div>
      <p>{{ 'collection.loading' | t | default: 'Caricamento prodotti...' }}</p>
    `;
    
    productGrid.style.position = 'relative';
    productGrid.appendChild(loader);
  }

  showProducts() {
    const loader = document.querySelector('.facets-loading-placeholder');
    if (loader) {
      loader.remove();
    }

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      productGrid.style.opacity = '1';
    }

    const productCount = document.getElementById('ProductCount');
    const productCountDesktop = document.getElementById('ProductCountDesktop');
    if (productCount) {
      productCount.style.opacity = '1';
    }
    if (productCountDesktop) {
      productCountDesktop.style.opacity = '1';
    }
  }

  resetSaleFilter() {
    const saleFilterCheckbox = this.querySelector('input[name="filter.p.m.filter.is_on_sale"][value="1"]');
    
    if (saleFilterCheckbox) {
      saleFilterCheckbox.checked = false;
    }
  }

  applyInitialSaleFilter() {
    if (this.dataset.saleFilter !== 'true') return;

    const urlParams = new URLSearchParams(window.location.search);
    
    if (!urlParams.has('filter.p.m.filter.is_on_sale')) {
      const saleFilterCheckbox = this.querySelector('input[name="filter.p.m.filter.is_on_sale"][value="1"]');
      if (saleFilterCheckbox && saleFilterCheckbox.checked) {
        saleFilterCheckbox.checked = false;
        return;
      }
    }

    if (urlParams.has('filter.p.m.filter.is_on_sale')) return;

    const saleFilterCheckbox = this.querySelector('input[name="filter.p.m.filter.is_on_sale"][value="1"]');
    if (saleFilterCheckbox && !saleFilterCheckbox.checked) {
      saleFilterCheckbox.checked = true;
      this.immediateSubmit();
    }
  }

  immediateSubmit() {
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const params = new URLSearchParams();

    sortFilterForms.forEach((form) => {
      const formParams = new URLSearchParams(this.createSearchParams(form));
      formParams.forEach((value, key) => {
        if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      });
    });

    this.isInitialSaleFilterLoad = true;
    FacetFiltersForm.renderPage(params.toString(), null);
  }

  initSearchFilter() {
    const searchInput = document.getElementById("facetsSearch");
    if (!searchInput) return;

    searchInput.addEventListener("input", () => {
      this.searchQuery = searchInput.value.toLowerCase(); 
      this.applySearchFilter(this.searchQuery); 
    });
  }

  applySearchFilter(query) {
    document.querySelectorAll("#FacetFiltersForm .accordion__section.facets__accordion-section").forEach((filterGroup) => {
      let hasVisibleOptions = false;
  
      filterGroup.querySelectorAll(".facets__item").forEach((option) => {
        const text = option.textContent.trim().toLowerCase();
        if (text.includes(query)) {
          option.style.display = "block"; 
          hasVisibleOptions = true;
        } else {
          option.style.display = "none";
        }
      });
  
      filterGroup.style.display = hasVisibleOptions ? "block" : "none";
    });
  }

  static syncCheckboxesWithURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(checkbox => {
      const paramName = checkbox.name;
      const paramValue = checkbox.value;
      
      if (paramName && paramValue) {
        const urlValues = urlParams.getAll(paramName);
        const shouldBeChecked = urlValues.includes(paramValue);
        
        if (checkbox.checked !== shouldBeChecked) {
          checkbox.checked = shouldBeChecked;
        }
      }
    });
    
    const saleFilterCheckbox = document.querySelector('input[name="filter.p.m.filter.is_on_sale"][value="1"]');
    if (saleFilterCheckbox) {
      const shouldBeChecked = urlParams.has('filter.p.m.filter.is_on_sale');
      if (saleFilterCheckbox.checked !== shouldBeChecked) {
        saleFilterCheckbox.checked = shouldBeChecked;
      }
    }
  }

  static restorePriceInputsFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const minPrice = urlParams.get('filter.v.price.gte');
    const maxPrice = urlParams.get('filter.v.price.lte');

    const minInput = document.querySelector('price-range input[name="filter.v.price.gte"]');
    const maxInput = document.querySelector('price-range input[name="filter.v.price.lte"]');

    if (minInput && minPrice !== null) minInput.value = minPrice;
    if (maxInput && maxPrice !== null) maxInput.value = maxPrice;
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static isCustomSortActive() {
    const grid = document.getElementById('product-grid');
    return !!(grid && grid.hasAttribute('data-tag-sort'));
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    const facetForm = document.querySelector('facet-filters-form');
    const isInitialSaleLoad = facetForm && facetForm.isInitialSaleFilterLoad;

    if (!isInitialSaleLoad) {
      document.getElementById('ProductGridContainer').querySelector('.collection-grid-container').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
      setTimeout(() => FacetFiltersForm.syncCheckboxesWithURL(), 100);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
        const facetForm = document.querySelector('facet-filters-form');
        if (facetForm && facetForm.isInitialSaleFilterLoad) {
          facetForm.showProducts();
          facetForm.isInitialSaleFilterLoad = false;
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    
    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm && facetForm.isInitialSaleFilterLoad) {
      facetForm.showProducts();
      facetForm.isInitialSaleFilterLoad = false;
    }

    if (window.dataColHandler) {
      const savedCols = localStorage.getItem('product-grid-col') || '4';
      window.dataColHandler.setActiveState(savedCols);
    }
  }

  static renderProductGridContainer(html) {
    const currentProductGrid = document.getElementById('ProductGridContainer');
    const productGrid = currentProductGrid?.querySelector('#product-grid');
    const currentColValue = productGrid?.getAttribute('data-col');
    
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    const savedCols = localStorage.getItem('product-grid-col') || currentColValue || '4';
    const newProductGrid = document.querySelector('#product-grid');
    if (newProductGrid) {
      newProductGrid.setAttribute('data-col', savedCols);
    }

    if (window.dataColHandler) {
      window.dataColHandler.setActiveState(savedCols);
    }

    if (typeof initializeMaterialPDPScripts === 'function') {
      initializeMaterialPDPScripts();
    }

    if (typeof initializeProductCardInteractions === 'function') {
      initializeProductCardInteractions();
    }

    if (typeof initializeEventListeners === 'function') {
      initializeEventListeners();
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
    });

    document.dispatchEvent(new CustomEvent('facets:renderComplete'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter');

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.restorePriceInputsFromURL();
    FacetFiltersForm.syncCheckboxesWithURL();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');
        const isTextInput = event.target.getAttribute('type') === 'text';
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    const facetFiltersForm = document.querySelector('facet-filters-form');
    if (facetFiltersForm && facetFiltersForm.searchQuery) {
      facetFiltersForm.applySearchFilter(facetFiltersForm.searchQuery);
    }

    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm) {
      facetForm.hideSingleOptionFilters();
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    let finalParams = searchParams;
    try {
      const isStoreSession = sessionStorage.getItem('is_store_session') === 'true';
      if (isStoreSession) {
        const params = new URLSearchParams(searchParams);
        if (!params.has('utm_source')) {
          params.set('utm_source', 'store');
          finalParams = params.toString();
        }
      }
    } catch (e) {}
    history.pushState({ searchParams: finalParams }, '', `${window.location.pathname}${finalParams && '?'.concat(finalParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static resetAllFilters() {
    document.querySelectorAll('facet-filters-form input[type="checkbox"]:checked').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    document.querySelectorAll('price-range input').forEach(input => {
      input.value = '';
    });
    
    FacetFiltersForm.renderPage('');
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    const params = new URLSearchParams();

    sortFilterForms.forEach((form) => {
      const formParams = new URLSearchParams(this.createSearchParams(form));
      formParams.forEach((value, key) => {
        if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      });
    });

    this.onSubmitForm(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    
    const url = event.currentTarget.href.indexOf('?') == -1
      ? ''
      : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    const currentUrl = new URLSearchParams(window.location.search);
    const newUrl = new URLSearchParams(url);
    
    const hadSaleFilter = currentUrl.has('filter.p.m.filter.is_on_sale');
    const hasSaleFilter = newUrl.has('filter.p.m.filter.is_on_sale');
    
    if (hadSaleFilter && !hasSaleFilter) {
      const saleFilterCheckbox = this.querySelector('input[name="filter.p.m.filter.is_on_sale"][value="1"]');
      if (saleFilterCheckbox) {
        saleFilterCheckbox.checked = false;
      }
    }
    
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Escape'];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute('data-max', maxInput.value);
    } else {
      minInput.setAttribute('data-max', maxInput.getAttribute('max'));
    }

    if (minInput.value) {
      maxInput.setAttribute('data-min', minInput.value);
    } else {
      maxInput.setAttribute('data-min', minInput.getAttribute('min'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('max'));

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);